export default function selectProductFormData(state) {
  return state?.app?.formData || {};
}
